<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">

        <a-row :gutter="12" style="margin:16px 25px;">
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;width:100%"
              label=""
              :required="false"
            >
              <j-dict-select-tag
                v-model="queryParam.status"
                placeholder="请选择上架状态"
                dictCode="shelf_status"/>
            </a-form-item>
          </a-col>

          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="请输入课程名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <a-button @click="courseCreate()" type="primary" icon="plus" style="float:right;">新增直播</a-button>

        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <div slot="courseinfo" slot-scope="text, record">
          <div class="course-img">
            <img :src="record.courseCoverUrl" alt="" width="86">
          </div>
          <div class="course-right">
            <div class="course-name">
              {{ record.courseName }}
            </div>
            <div class="course-money">
              {{ record.buyType==0?("免费"):("￥"+record.realPrice+"元") }}

            </div>
          </div>
        </div>

        <span slot="action" slot-scope="text, record" style="width:300px">
          <!-- <a @click="handleEdit(record)">编辑</a> -->
          <a-popconfirm title="确定下架吗?" v-if="record.courseStatus==1" @confirm="() => offShelfCourse(record.id)">
            <a>下架</a>
          </a-popconfirm>
          <a-popconfirm title="确定上架吗?" v-else @confirm="() => offShelfCourse(record.id)">
            <a>上架</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="courseDetail(record.id)">课程详情</a>
          <a-divider type="vertical" />
          <a @click="courseEdite(record.id)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">

              <a-menu-item>

              </a-menu-item>

              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <!-- <courseCreate-modal ref="modalForm" @ok="modalFormOk"/> -->

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { updateOnlineVideoShelf } from '@/api/api'
  // import CourseCreateModal from '../../../components/myCourse/myCourseList/CourseCreateModal'

  export default {
    name: 'OnlineVideoList',
    mixins: [JeecgListMixin],
    components: {

    },
    data () {
      return {
        description: '课程管理页面',
        sex: '0',
        queryParam: {
          name: '',
          status: ''
        },
        // 表头
        columns: [

          {
            title: '课程名称',
            align: 'center',
            dataIndex: 'courseName',
            width: 100,
            scopedSlots: { customRender: 'courseinfo' }
          },
          {
            title: '销量',
            align: 'center',
            dataIndex: 'sales',
            width: 100,
            customRender: (text, row, index) => {
              return (<span >{row.sales ? row.sales : 0}</span>)
            }
          },
          {
            title: '开课时间',
            align: 'center',
            dataIndex: 'courseStartDate',
            width: 100,
            customRender: (text, row, index) => {
              return (<span >{row.courseStartDate ? row.courseStartDate : '-'}</span>)
            }
          },
          {
            title: '开课进度',
            align: 'center',
            dataIndex: 'courseDetail',
            customRender: (text, row, index) => {
              return (<span style='color:#333;font-size:12px;'>{row.startCnt ? row.startCnt : 0}/{row.totalCnt ? row.totalCnt : 0}</span>)
            },
            width: 100
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'courseStatus',
            width: 100,
            customRender: (text, row, index) => {
              return (<span style='color:#333;font-size:12px;'>{row.courseStatus == 1 ? '已上架' : <span style="color:#71818E">已下架</span>}</span>)
            }
          },
          {
             title: '序号',
             align: 'center',
             dataIndex: 'courseOrder',
             width: 100
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 260
          }
        ],
        dataSource: [
        ],
        // 请求参数
    	url: {
            list: '/live/course/list',
            delete: '/live/course/delete'
            // deleteBatch: "/course/elinkxCourse/deleteBatch",
            // exportXlsUrl: "course/elinkxCourse/exportXls",
            // importExcelUrl: "course/elinkxCourse/importExcel",
          }
        }
      },
      computed: {
        importExcelUrl: function() {
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
        }
      },

    methods: {

      courseCreate() {
        this.$router.push({ path: '/onlineVideo/onlineVideoCreate' })
      },

      courseDetail(id) {
        this.$router.push({ path: '/onlineVideo/onlineVideoDetailEdite?courseId=' + id })
      },
      courseEdite(id) {
        this.$router.push({ path: '/onlineVideo/onlineVideoCreate?courseId=' + id })
      },
      offShelfCourse(id) {
        updateOnlineVideoShelf({ id: id }).then((res) => {
          if (res.code == 0) {
            console.log(res)
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >
  .course-img{
    float: left;
  }
  .course-right{
    padding-left:10px;
    text-align:left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left:90px;
    .course-name{
      font-size:14px;
      color: #0091FF;
      padding: 10px 0px;
    }
    .course-money{
      font-size:14px;
      color: #FA6400;

    }
  }
</style>
